// Store utm data in a cookie.
if (window.location.search) {
  const params = new URLSearchParams(window.location.search).toString();
  if (params) {
    document.cookie = `utm=${params}; path=/; max-age=86400`;
  }
}
